<template>
  <vxe-grid ref="rockTableTree" v-bind="gridOptions" v-on="$listeners">
    <template #operate="{ row }">
      <slot name="operate" :row="row"/>
    </template>
  </vxe-grid>
</template>

<script>
import {mapGetters} from "vuex";

const initialOptions = {
  border: "outer", // default（默认）, full（完整边框）, outer（外边框）, inner（内边框）, none（无边框）
  height: "auto",
  resizable: true,
  // columns: [{ type: "checkbox", treeNode: true }], // 含有多选
  columns: [{field: "name", treeNode: true}], // 不含树形
  showOverflow: true,
  rowKey: true,
  rowConfig: {
    keyField: "id",
    isHover: true,
    isCurrent: true,
  },
  showHeader: false,
  checkboxConfig: {
    labelField: "name",
  },
  treeConfig: {
    transform: true,
    rowField: "id",
    parentField: "parentId",
    children: "children",
    indent: 18,
    line: false, // 树节点的连接线（启用连接线会降低渲染性能）
    // expandAll: false, // 默认展开所有子孙树节点（只会在初始化时被触发一次）
    // expandRowKeys: [], // 默认展开指定树节点（只会在初始化时被触发一次，需要有 row-id）
    // accordion: false, // 对于同一级的节点，每次只能展开一个
    iconOpen: "el-icon-caret-bottom",
    iconClose: "el-icon-caret-right",
  },
};

export default {
  name: "RockTableTree",
  install(Vue) {
    Vue.component("RockTableTree", this);
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      gridOptions: undefined,
    };
  },
  computed: {
    ...mapGetters({
      vxeSize: "vxeSize",
      isMobile: "isMobile",
    }),
  },
  watch: {
    options: {
      handler(val) {
        const cloneInitialOptions = this._.cloneDeep(initialOptions);
        let cloneOptions = this._.cloneDeep(val);
        if (this.isMobile && val.columns && val.columns.length) {
          cloneOptions.columns = val.columns.filter(
              (item) => item.disableCheck
          );
        }
        this.gridOptions = this._.merge(cloneInitialOptions, cloneOptions, {
          size: "small",
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getTableData() {
      return this.$refs.rockTableTree.getTableData();
    },

    loadData(data) {
      this.$refs.rockTableTree.loadData(data);
    },

    reloadData(data) {
      this.$refs.rockTableTree.reloadData(data);
    },

    // 根据行的唯一主键获取行（需要 row-config.keyField）
    getRowById(rowId) {
      return this.$refs.rockTableTree.getRowById(rowId);
    },

    // 用于 row-config.isCurrent，设置某一行为高亮状态
    setCurrentRow(row) {
      this.$refs.rockTableTree.setCurrentRow(row);
    },
    // 用于 row-config.isCurrent，手动清空当前高亮的状态
    clearCurrentRow() {
      this.$refs.rockTableTree.clearCurrentRow();
    },

    // 获取当前已选中的行数据（当前列表，如果 isFull=true 则获取全表已选中的数据）
    getCheckboxRecords(isFull) {
      return this.$refs.rockTableTree.getCheckboxRecords(isFull);
    },

    // 获取半选状态的行数据（当前列表，如果 isFull=true 则获取全表已选中的数据）
    getCheckboxIndeterminateRecords(isFull) {
      return this.$refs.rockTableTree.getCheckboxIndeterminateRecords(isFull);
    },

    // 用于 type=checkbox，设置所有行的选中状态：boolean
    setAllCheckboxRow(checked) {
      this.$refs.rockTableTree.setAllCheckboxRow(checked);
    },

    // 设置行为选中状态，第二个参数为选中与否
    async setCheckboxRow(rows, checked) {
      this.$refs.rockTableTree.setCheckboxRow(rows, checked);
    },

    // 判断复选行数据是否勾选
    isCheckedByCheckboxRow(row) {
      return this.$refs.rockTableTree.isCheckedByCheckboxRow(row);
    },

    // 判断复选行数据是否半选
    isIndeterminateByCheckboxRow(row) {
      return this.$refs.rockTableTree.isIndeterminateByCheckboxRow(row);
    },

    // 用于 type=checkbox，手动清空用户的选择
    clearCheckboxRow() {
      this.$refs.rockTableTree.clearCheckboxRow();
    },

    // 用于 checkbox-config.reserve，手动清空用户保留选中的行数据
    clearCheckboxReserve() {
      this.$refs.rockTableTree.clearCheckboxReserve();
    },

    // 用于 tree-config，设置所有树节点的展开与否（如果是关闭所有树节点，可以使用 clearTreeExpand 快速清除）
    setAllTreeExpand(checked) {
      this.$refs.rockTableTree.setAllTreeExpand(checked);
    },
    // 用于 tree-config，设置展开树形节点，二个参数设置这一行展开与否
    setTreeExpand(rows, checked) {
      this.$refs.rockTableTree.setTreeExpand(rows, checked);
    },
    // 用于 tree-config，用于树表格，获取已展开的节点（注意，即使父节点被收起，只要该节点还处于展开状态都能获取到）
    getTreeExpandRecords() {
      return this.$refs.rockTableTree.getTreeExpandRecords();
    },
    // 用于 tree-config，判断行是否为树形节点展开状态
    isTreeExpandByRow(row) {
      return this.$refs.rockTableTree.isTreeExpandByRow(row);
    },
  },
};
</script>
